import { Helmet } from 'react-helmet-async'

const SEO = ({
  title,
  description,
  keywords,
  image,
  url,
  type = 'website',
  siteName = '3afer',
  locale = 'ar_SA',
  alternateLocales = [],
  structuredData,
  noindex = false,
  nofollow = false,
  canonical,
}) => {
  const siteUrl = typeof window !== 'undefined' ? window.location.origin : 'https://3afer.net'
  const fullUrl = url ? `${siteUrl}${url}` : (typeof window !== 'undefined' ? window.location.href : siteUrl)
  const fullImage = image ? (image.startsWith('http') ? image : `${siteUrl}${image}`) : `${siteUrl}/logo.png`
  const canonicalUrl = canonical || fullUrl

  // Default values
  const defaultTitle = '3afer - تعلّم أونلاين من أكبر مكتبة كورسات في الوطن العربي'
  const defaultDescription = 'تعلّم أونلاين من أكبر مكتبة كورسات في الوطن العربي. دورات تعليمية احترافية في مختلف المجالات مع أفضل المدربين العرب.'
  const defaultKeywords = 'تعليم, دورات, كورسات, أونلاين, تعليم إلكتروني, دورات عربية, تعلم مجاني, شهادات معتمدة'

  const finalTitle = title ? `${title} | ${siteName}` : defaultTitle
  const finalDescription = description || defaultDescription
  const finalKeywords = keywords || defaultKeywords

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{finalTitle}</title>
      <meta name="description" content={finalDescription} />
      <meta name="keywords" content={finalKeywords} />
      {noindex && <meta name="robots" content="noindex" />}
      {nofollow && <meta name="robots" content="nofollow" />}
      {!noindex && !nofollow && <meta name="robots" content="index, follow" />}
      
      {/* Canonical URL */}
      <link rel="canonical" href={canonicalUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={finalTitle} />
      <meta property="og:description" content={finalDescription} />
      <meta property="og:image" content={fullImage} />
      <meta property="og:url" content={fullUrl} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:locale" content={locale} />
      {alternateLocales.map(loc => (
        <meta key={loc} property="og:locale:alternate" content={loc} />
      ))}

      {/* Twitter Card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={finalTitle} />
      <meta name="twitter:description" content={finalDescription} />
      <meta name="twitter:image" content={fullImage} />

      {/* Language Alternates */}
      <link rel="alternate" hrefLang="ar" href={fullUrl} />
      {alternateLocales.map(loc => (
        <link key={loc} rel="alternate" hrefLang={loc} href={fullUrl} />
      ))}

      {/* Structured Data (JSON-LD) */}
      {structuredData && (
        <>
          {Array.isArray(structuredData) ? (
            structuredData.map((data, index) => (
              data && (
                <script key={index} type="application/ld+json">
                  {JSON.stringify(data)}
                </script>
              )
            ))
          ) : (
            <script type="application/ld+json">
              {JSON.stringify(structuredData)}
            </script>
          )}
        </>
      )}
    </Helmet>
  )
}

export default SEO
